import { Typography } from "@material-ui/core";
import { DTPMessage } from "meu-inss-ds";
import { useSelector } from "react-redux";
import { formatarCpf } from "shared/helper/formatadores";
import { capitalize, getFirstAndLastName } from "shared/helper/utilitarioString";
import './painelProcurador.css'

export function PainelProcurador() {


    const usuario = useSelector(state => state.session.usuario)

    return (
        <>        
        {
        usuario && usuario.isProcurador &&  
        <div tabIndex={0} aria-label="Painel Procurador" className="painel-procurador">
            <DTPMessage tabIndex={-1} type="info"  message={
            <div tabIndex={-1} style={{display:'flex', alignItems:'center'}}>                
                <div tabIndex={-1} style={{ display: 'flex', flexDirection: 'column'}}  >                               
                    <div tabIndex={0} aria-label={`Procurador: ${getFirstAndLastName(usuario.nomeProcurador)}. CPF: ${usuario.cpfProcurador}`} style={{ display: 'flex', marginRight: '5px', alignItems:'center'}}>
                        <label style={{ marginRight: '6px', fontWeight: '600' }}>{usuario && usuario.nomeProcurador ? 'Procurador ': ''}</label>
                        <label style={{ fontWeight: '500' }}> {capitalize(getFirstAndLastName(usuario.nomeProcurador)) + '  -  '} </label>
                        <label style={{ marginLeft: '4px', fontWeight: '500' }}>{usuario && usuario.cpfProcurador ? 'CPF ' + formatarCpf(usuario.cpfProcurador) : ''}</label>
                    </div>
                    <div tabIndex={0} aria-label={`Representado: ${getFirstAndLastName(usuario.nome)}. CPF: ${usuario.cpf}`} style={{ display: 'flex', marginRight: '5px', alignItems:'center'}} >
                        <label style={{ marginRight: '6px', fontWeight: '600' }}>{usuario && usuario.cpf ? 'Representado ': ''}</label>
                        <label style={{ fontWeight: '500' }}> {capitalize(getFirstAndLastName(usuario.nome)) + (usuario.nome ? '  -  ' : '')} </label>
                        <label style={{ marginLeft: '4px', fontWeight: '500' }}>{usuario && usuario.cpf ? "CPF " + formatarCpf(usuario.cpf) : ''}</label>
                    </div>
                </div> 
                
            </div>
            }>  
            
            </DTPMessage>     
        </div>
        }
        </>
    )

}